module.exports = __webpack_public_path__ + "static/img/质量安全管理优秀企业证书.2af71f76.jpg";